// @flow
const getContactHref = (name: string, contact: string) => {
  let href;

  switch (name) {
    case 'twitter':
      href = `https://www.twitter.com/${contact}`;
      break;
    case 'github':
      href = `https://github.com/${contact}`;
      break;
    case 'vkontakte':
      href = `https://vk.com/${contact}`;
      break;
    case 'telegram':
      href = `telegram:${contact}`;
      break;
    case 'email':
      href = `mailto:${contact}`;
      break;
    case 'instagram':
      href = `https://instagram.com/${contact}`;
      break;
    case 'tiktok':
      href = `https://tiktok.com/${contact}`;
      break;
    case 'bluesky':
      href = `https://bsky.app/${contact}`;
      break;
    case 'substack':
      href = `https://${contact}.substack.com`;
      break;
    case 'google-scholar':
      href = `https://scholar.google.com/citations?user=${contact}`;
      break;
    case 'x-twitter':
      href = `https://x.com/${contact}`;
      break;
    default:
      href = contact;
      break;
  }

  return href;
};

export default getContactHref;
